import React from 'react';
import { Card, CardContent } from '../../components/ui/card';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '../../components/ui/select';
import EmployeeSuggest from '../../components/EmployeeSuggest';
import { JOB_TITLES } from '../../components/employees/EmployeeFormDialog';

export const EmployeesFilters = ({
  search, onSuggestSelect,
  filterStatus, onFilterStatus,
  filterJobTitle, onFilterJobTitle,
}) => (
  <Card className="border-slate-200">
    <CardContent className="pt-6">
      <div className="flex flex-col sm:flex-row gap-4">
        <div className="flex-1">
          <EmployeeSuggest
            onSelect={onSuggestSelect}
            placeholder="Search by name or employee ID..."
            value={search}
            className="w-full"
          />
        </div>
        <Select
          value={filterStatus || 'all'}
          onValueChange={(val) => onFilterStatus(val === 'all' ? '' : val)}
        >
          <SelectTrigger className="w-full sm:w-40" data-testid="status-filter">
            <SelectValue placeholder="All Status" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Status</SelectItem>
            <SelectItem value="Active">Active</SelectItem>
            <SelectItem value="Needs completion">⚠ Needs completion</SelectItem>
            <SelectItem value="Inactive">Inactive</SelectItem>
            <SelectItem value="Terminated">Terminated</SelectItem>
          </SelectContent>
        </Select>
        <Select
          value={filterJobTitle || 'all'}
          onValueChange={(val) => onFilterJobTitle(val === 'all' ? '' : val)}
        >
          <SelectTrigger className="w-full sm:w-40" data-testid="job-filter">
            <SelectValue placeholder="All Roles" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Roles</SelectItem>
            {JOB_TITLES.map((j) => (
              <SelectItem key={j.value} value={j.value}>{j.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </CardContent>
  </Card>
);

export default EmployeesFilters;
